<template>
    <div class="home-page">
		<Header></Header>
		<div class="home-content mt50">
      <div class="content crfff ac por">
       <div class="fs50" v-html="$t('indexTips1')"></div>
        <div class="fs26 mt30 cr0062ff">{{$t('indexTips2')}} :</div>
        <button  class="button mt30 crfff snapbot-btn" @click="goDetail('/snapbot')"></button>
        <div class="disflex mt50" style="justify-content:center;width: calc(100% - 80px);">
          <div class="crfb7925 fs27 fw7">
            {{$t('ChancesLeft')}}: {{score}}
          </div>
<!--          <div class="fs27 fw7" style="color:#FFC107" @click="goPurchaseChances">{{$t('BuyChances')}}</div>-->
        </div>
        <div class="mt50">
          <div class="land-content al">

            <div  v-for="(item,index) in product">
              <div  class="two" @click="goDetail(item.web_path)" >
                <img v-if="item.is_new" style="position: absolute;right: 0px;top: -20px;width: 40%" src="../../static/images/Festival_icon.png"/>
                <div class="fs36">{{item.title}}</div>
                <img :src="item.image" loading="lazy" />
                <div class="disflex">
                  <span class="fs26">{{item.title_tip}}</span>
                  <button class="button mt30 crfff">
                    {{$t('letgo')}}<img src="../../static/images/go.png" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
		</div>
    <div class="footer mt100">
        <div class="home-bottom ac mt50">
          <div class="footer-content ac">
            <a class="crfff" href="#/faq">{{$t('FAQ')}}</a>
            <a class="crfff" href="#/termsAndCondition">{{$t('TC')}}</a>
          </div>
        </div>
        <div class="copyright">{{$t('Copyright')}}</div>
      </div>
      <!-- Spin Wheel 弹窗 -->
    <div v-if="showSpinPopup" class="spin-popup">
        <div class="popup-overlay" @click="closeSpinPopup"></div>
        <div class="popup-content">
          <div class="popup-title">{{$t('spin_tip_1')}}</div>
          <div class="popup-subtitle">
            {{$t('spin_tip_2')}}
          </div>
          <div class="wheel-container" @click="goSpinPage">
            <img src="../../static/images/spin_wheel.png" alt="wheel" class="wheel-img" />
          </div>
          <button class="letsgo-btn" @click="goSpinPage"></button>
          <div class="close" @click="closeSpinPopup">{{$t('close')}}</div>
        </div>
      </div>
	</div>

</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        info:{},
        isShow:1,
        isEN:'bur',
        score:'',
        mobile:'',
        switchFeature:false,
        product:{},
        showSpinPopup: false,
      }
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
    this.isEN = localStorage.getItem('lang')
    if(this.$route.query.msisdn){
      this.mobile = this.$route.query.msisdn
      this.getLogin()
    }else{
      this.getHome()
      this.getProduct()
    }
    //抽奖弹窗
    // if (!localStorage.getItem('setTime_v1') || (localStorage.getItem('setTime_v1') &&
    //     Date.parse(new Date()) - localStorage.getItem('setTime_v1') >= 86400000)) {//86400000 24h
    //     localStorage.removeItem('setTime_v1');
    //     localStorage.setItem('setTime_v1', Date.parse(new Date()));
    //     this.openSpinPopup();
    // }
	},
    methods: {
      getLogin(){
        let that = this
        that.$parent.loadModal(true);
        let data = {
          mobile:that.mobile
        }
        that.$api.post('/api/user/fast_login',data,r =>{
          that.$parent.loadModal(false);
          if(r.code==1){
            localStorage.setItem('token',r.data.userinfo.token)
            localStorage.setItem('mobile',r.data.userinfo.mobile)
            this.getHome();
            this.getProduct();
          }else{
            that.$utils.alertText(r.msg,80);
            this.$router.push({path:'/login',query: {msisdn:that.mobile}})
          }
        })
      },
      getHome(){
      	let that =this;
      	that.$api.get('/api/user/info',null,r =>{
      		that.$parent.returnCode(r,function(){
            that.score=r.data.score
            that.switchFeature=r.data.switch
          });
      	})
      },
      getProduct(){
        let that =this;
        that.$api.get('/api/index/index_product',null,r =>{
          that.$parent.returnCode(r,function(){
            that.product=r.data
          });
        })
      },
      goDetail(path){
        this.$router.push({path:path});
      },
      goNext(type){
        if(type==1){
          this.$router.push({path:'/generateImage'});
        }else if(type==5){
          this.$router.push({path:'/picture',query: {type:type}});
        }else if(type==4){
          this.$router.push({path:'/petPicture',query: {type:type}});
        }else if(type==3){
          this.$router.push({path:'/sexPicture',query: {type:type}});
        }else if(type==2){
          this.$router.push({path:'/cartoonYourself',query: {type:type}});
        }else if(type==6){
          this.$router.push({path:'/idCard',query: {type:type}});
        }else if(type==7){
          this.$router.push({path:'/snapbot',query: {type:type}});
        }else if(type==8){
          this.$router.push({path:'/oldPicColor',query: {type:type}});
        }else if(type==9){
          this.$router.push({path:'/bgFusion',query: {type:type}});
        }else if(type==10){
          this.$router.push({path:'/changeHairstyle',query: {type:type}});
        }else {
          this.$utils.alertText(this.$t('comingsoonT'),80);
          return;
        }

      },

      goPurchaseChances(){
        this.$router.push({path:'/purchaseChances'})
      },
      openSpinPopup() {
        this.showSpinPopup = true;
      },
      closeSpinPopup() {
        this.showSpinPopup = false;
      },
      goSpinPage() {
        this.$router.push({ path: '/spin' });
      }
	}
}
</script>
<style scoped>
/*  .close{
    background: rgb(255 255 255 / 20%);
    color: #fff;
    width: 100px;
    height: 100px;
    font-size: 60px;
    margin: 30px auto 0;
    border-radius: 100px;
  }*/
  .new-img{margin: 40px 40px 0;width: auto;}
  .new-img .img-b{width: 48%;border: 4px solid #0062ff;
    border-radius: 10px;}
  .img-b img{width: 100%;border-radius: 10px;}
  .snapbot-btn {
    background: url('../../static/images/snapbot-btn.png') no-repeat center center;
    background-size: contain;
    width: 500px;
    height: 90px;
    border: none;
  }
  .spin-btn {
    background: url('../../static/images/lucky_spin_btn.png') no-repeat center center;
    background-size: contain;
    width: 500px;
    height: 90px;
    border: none;
  }

  .spin-popup {
    position: fixed;
    z-index: 9999;
    top: 0; left: 0;
    width: 100%;
    height: 100%;
  }

  .popup-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.7);
    backdrop-filter: blur(4px);
  }

  .popup-content {
    position: absolute;
    top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: #fff;
    width: 90%;
  }

  .popup-title {
    font-size: 45px;
    font-weight: 700;
    margin-bottom: 10px;
  }

  .popup-subtitle {
    font-size: 30px;
    color: #7fffd4;
    margin: 20px auto 20px;
  }

  .wheel-container {
    position: relative;
  }

  .wheel-img {
    width: 100%;
    border-radius: 50%;
  }

  .letsgo-btn {
    background: url('../../static/images/let_go.png') no-repeat center center;
    background-size: contain;
    padding: 70px 180px;
  }

  .close {
    color: #fff;
    width: 100px;
    height: 50px;
    font-size: 30px;
    margin: 20px auto 0;
    border-radius: 25px;
    line-height: 50px;
  }

</style>



// WEBPACK FOOTER //
// src/page/index.vue